import { apiGet, apiPost, apiDelete } from './client';

// Phase 113 (MKS-208) — project-month entry locks.

/** The error code the backend attaches when a write hits a locked month. */
export const PROJECT_MONTH_LOCKED_CODE = 'PROJECT_MONTH_LOCKED';

export interface ProjectMonthLock {
  id: number;
  projectId: number;
  year: number;
  /** 1-indexed, matching the backend column. */
  month: number;
  note: string | null;
  lockedBy: { id: number; name: string | null } | null;
  createdAt: string;
}

export interface LockProjectMonthInput {
  year: number;
  month: number;
  note?: string;
}

/** `${projectId}-${YYYY}-${MM}` — the key the time grid looks cells up by. */
export function monthLockKey(projectId: number, year: number, month: number): string {
  return `${projectId}-${year}-${String(month).padStart(2, '0')}`;
}

/** The same key from an ISO date string, which is what a grid cell carries. */
export function monthLockKeyForDate(projectId: number, isoDate: string): string {
  return `${projectId}-${isoDate.slice(0, 7)}`;
}

export async function getMonthLocks(year: number, month: number): Promise<ProjectMonthLock[]> {
  const res = await apiGet<{ data: ProjectMonthLock[] }>(
    `/project-month-locks?year=${year}&month=${month}`,
  );
  return res.data;
}

export async function getProjectMonthLocks(projectId: number): Promise<ProjectMonthLock[]> {
  const res = await apiGet<{ data: ProjectMonthLock[] }>(`/projects/${projectId}/month-locks`);
  return res.data;
}

export async function lockProjectMonth(
  projectId: number,
  input: LockProjectMonthInput,
): Promise<ProjectMonthLock> {
  const res = await apiPost<{ data: ProjectMonthLock }>(
    `/projects/${projectId}/month-locks`,
    input,
  );
  return res.data;
}

export async function unlockProjectMonth(
  projectId: number,
  year: number,
  month: number,
): Promise<void> {
  await apiDelete<{ data: { success: boolean } }>(
    `/projects/${projectId}/month-locks/${year}/${month}`,
  );
}
